import { jsx as c } from "react/jsx-runtime";
import i from "react";
import { clsx as m } from "../../utils/clsx.js";
import '../../assets/Loaf.css';const n = "_root_gg27t_1", f = "_bright_gg27t_14", o = {
  root: n,
  "color-normal": "_color-normal_gg27t_10",
  bright: f,
  "color-gold": "_color-gold_gg27t_17",
  "color-error": "_color-error_gg27t_24",
  "size-small": "_size-small_gg27t_32",
  "size-normal": "_size-normal_gg27t_39",
  "size-large": "_size-large_gg27t_46"
}, p = i.forwardRef(function(r, t) {
  const {
    size: l = "normal",
    color: s = "normal",
    bright: _ = !1,
    children: g,
    className: a
  } = r, e = m(o.root, o[`size-${l}`], o[`color-${s}`], a, {
    [o.bright]: _
  });
  return /* @__PURE__ */ c("div", { ref: t, className: e, children: g });
});
export {
  p as Loaf
};
